export const transformItemsToUpdateInCategory = (
  initialItems = [],
  allItems = [],
  currentValueItems = [],
  currentCategoryUuid = ''
) => {
  const deletedItems = initialItems.filter(
    (item) => !currentValueItems.includes(item)
  )
  const itemsWithDeletedCategoryUuids = allItems.filter((item) =>
    deletedItems.includes(item.uuid)
  )

  const filteredCategoryUuidInDeletedItem =
    itemsWithDeletedCategoryUuids.reduce((result, item) => {
      const filteredUuid = item.itemCategoryUuids.filter((item) => {
        return item !== currentCategoryUuid
      })

      const itemWithFilteredCategoryUuid = {
        ...item,
        itemCategoryUuids: filteredUuid,
      }

      return [...result, itemWithFilteredCategoryUuid]
    }, [])

  const itemsWithCategoryUuidsToAdd = allItems.filter((item) =>
    currentValueItems.includes(item.uuid)
  )

  const itemsWithUpdatedCategoryUuids =
    itemsWithCategoryUuidsToAdd.reduce((result, item) => {
      const itemWithFilteredCategoryUuid = {
        ...item,
        itemCategoryUuids: [
          ...item.itemCategoryUuids,
          currentCategoryUuid,
        ],
      }

      return item.itemCategoryUuids.includes(currentCategoryUuid)
        ? [...result]
        : [...result, itemWithFilteredCategoryUuid]
    }, [])

  return [
    ...filteredCategoryUuidInDeletedItem,
    ...itemsWithUpdatedCategoryUuids,
  ]
}
